<div class="position-reletivediv popup-inner-space d-flex border-bottom-grey">
    <div class="betweenheader color_black col-lg-11 d-flex justify-content-between px-0">
        <div class="d-flex">
            <h6 class="m-auto font_14">Site Name: {{SiteName}}</h6>
        </div>
        <div class="d-flex">
            <h6 class="m-auto font_14">Panel Name: {{PanelName}}</h6>
        </div>
        <div class="d-flex">
            <h6 class="m-auto font_14">MeterId: {{meterId}}</h6>
        </div>
    </div>
    <div class="text-right flow-right col-lg-1 px-0">
        <img src="assets/images/close_icon.svg" alt="..." class="img-fluid closeicon2 cursor-pointer" (click)="Close()">
    </div>
</div>
<div class="container-data56 margin-top-30 ml-3">
    <div class="errmsg error-fix" *ngIf="errorMsg">{{errorMsg}}</div>
    <div class="sucessmsg  error-fix" *ngIf="successMsg">{{successMsg}}</div>
</div>
<form class="" [formGroup]="reportDataForm">
    <div class="row mlr-0">
        <div class="col-lg-3 mt-1 pr-0">
            <div class="fxg-field fxg-field2">
                <mat-form-field style="display:block;" title="Register Name">
                    <mat-select formControlName="RegisterDataId">
                        <mat-option value="">(Select RegisterName)</mat-option>
                        <mat-option MatFormFieldControl="RegisterDataId" *ngFor="let lstregister of RegisterData"
                            value="{{lstregister.RegisterDataId}}">
                            {{lstregister.RegisterName}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <span class="error_msg" *ngIf="displayMessage.RegisterDataId">{{displayMessage.RegisterDataId}}</span>
            </div>
        </div>
        <div class="margin-left-10 mt-1">
            <button class="btncommon " (click)="AddReportData()">Add</button>
        </div>
    </div>
    <div class="table-scroll-newsite tableBR">
        <table class="table table-layout-fixed">
            <thead class="companytable thead-data td-data-main">
                <tr class="tr-padding">
                    <th class="width-10 color_black">SeqNo</th>
                    <th class="color_black">RegisterName</th>
                    <th class="width-40 color_black">TagId</th>
                    <th class="color_black" *ngIf="this.ReportNameflag==true">For Total Cal.</th>
                    <th class="text-right"></th>
                </tr>
            </thead>
            <tbody clas="table-responsive-sechedule">
                <tr *ngFor="let lstreport of ReportDataList; let i = index">
                    <td class="width-10">{{i + 1}}</td>
                    <td class="">{{lstreport.RegisterName}}</td>
                    <td class="width-40">{{lstreport.TagId}}</td>
                    <td class="" *ngIf="this.ReportNameflag==true">
                        <input type="checkbox" [(ngModel)]="lstreport.selected" [checked]="lstreport.IsForTotal"
                            (change)="onCheckboxChange(lstreport.RegisterDataId, $event.target.checked)">
                    </td>
                    <td class=" text-right">
                        <img src="assets/images/uparrow.svg" alt="..." class="img-fluid closeicon2 cursor-pointer mr-2"
                            (click)="UpDownReportData(i, 'UP')" id="upreportdata_icon" *ngIf="i != 0">
                        <img src="assets/images/downarrow.svg" alt="..."
                            class="img-fluid closeicon2 cursor-pointer mr-2" (click)="UpDownReportData(i, 'DOWN')"
                            id="downreportdata_icon" *ngIf="i != ReportDataList.length - 1">
                        <img src="assets/images/delete.svg" alt="..." class="img-fluid closeicon2 cursor-pointer"
                            (click)="DeleteReportData(lstreport.RegisterDataId)" id="delete_icon">
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</form>
<div class="company-btn2">
    <button id="btnReportDataSave" class="btncommon btn-orange btn-border-add-company  width-fix67  ml-24"
        (click)="SaveReportData()" *ngIf="ReportDataList && ReportDataList.length > 0">Save</button>
</div>